/**
 * Custom GSAP Animations for Webflow to Shopify Theme Conversion
 * 
 * Usage:
 * Add the corresponding `data-gsap` attribute to your <a> or <button> elements.
 * Example: <a href="#" data-gsap="primary" class="primary-btn">Button</a>
 */
document.addEventListener("DOMContentLoaded", () => {
  if (typeof gsap === "undefined") {
    console.warn("GSAP is not loaded. Please make sure the GSAP CDN is in your theme.liquid.");
    return;
  }

  const initPrimaryButtons = () => {
    // 1. Primary Buttons with Gradient Outlines => data-gsap="primary"
    document.querySelectorAll('[data-gsap="primary"]').forEach((btn) => {
      if (btn.dataset.gsapInit) return;
      btn.dataset.gsapInit = true;

      const leftOutline = btn.querySelector(".button-hover-outline.left");
      const middleOutline = btn.querySelector(".button-hover-outline.middle");
      const rightOutline = btn.querySelector(".button-hover-outline.right");

      gsap.set(btn, { scale: 1 });
      if (leftOutline || middleOutline || rightOutline) {
        gsap.set([leftOutline, middleOutline, rightOutline], { width: "0%" });
      }

      const hoverInTl = gsap.timeline({ paused: true });
      hoverInTl.to(btn, { scale: 0.97, duration: 0.7, ease: "quad.out" }, 0);

      if (leftOutline) hoverInTl.to(leftOutline, { width: "100%", duration: 0.2, ease: "none" }, 0);
      if (middleOutline) hoverInTl.to(middleOutline, { width: "100%", duration: 0.3, ease: "none" }, 0.2);
      if (rightOutline) hoverInTl.to(rightOutline, { width: "110%", duration: 0.15, ease: "none" }, 0.5);

      btn.addEventListener("mouseenter", () => hoverInTl.play());
      btn.addEventListener("mouseleave", () => hoverInTl.reverse());
    });
  };

  const initSecondaryButtons = () => {
    // 2. Secondary Buttons with Underline Slide & Arrow Loop => data-gsap="secondary"
    document.querySelectorAll('[data-gsap="secondary"]').forEach((btn) => {
      if (btn.dataset.gsapInit) return;
      btn.dataset.gsapInit = true;

      const underline = btn.querySelector(".underline");
      const arrow = btn.querySelector(".button-arrow");

      if (underline) gsap.set(underline, { xPercent: 0 });
      if (arrow) gsap.set(arrow, { x: 0 });

      const arrowTl = gsap.timeline({ paused: true });
      if (arrow) {
        arrowTl.to(arrow, { x: 15, duration: 0.3, ease: "quad.out" })
               .set(arrow, { x: -15 })
               .to(arrow, { x: 0, duration: 0.3, ease: "quad.out" });
      }

      btn.addEventListener("mouseenter", () => {
        if (arrow && !arrowTl.isActive()) arrowTl.restart();
        if (underline) gsap.to(underline, { xPercent: 101, duration: 0.5, ease: "power3.out", overwrite: "auto" });
      });

      btn.addEventListener("mouseleave", () => {
        if (underline) gsap.fromTo(underline, { xPercent: -101 }, { xPercent: 0, duration: 0.5, ease: "power3.out", overwrite: "auto" });
      });
    });
  };

  const initCounterArrowButtons = () => {
    // 3. Simple Arrow Buttons (Move 3px) => data-gsap="counter-arrow"
    document.querySelectorAll('[data-gsap="counter-arrow"]').forEach((btn) => {
      if (btn.dataset.gsapInit) return;
      btn.dataset.gsapInit = true;

      const arrowImg = btn.querySelector(".button-arrow");
      if (arrowImg) {
        gsap.set(arrowImg, { x: 0, y: 0 });

        const hoverTl = gsap.timeline({ paused: true });
        hoverTl.to(arrowImg, { x: 3, y: -3, duration: 0.2, ease: "power1.inOut" });

        btn.addEventListener("mouseenter", () => hoverTl.play());
        btn.addEventListener("mouseleave", () => hoverTl.reverse());
      }
    });
  };

  const initScrollArrowButtons = () => {
    // 4. Scroll Arrow Buttons (pill-shaped, arrow moves 3px top-right) => data-gsap="scroll-arrow"
    document.querySelectorAll('[data-gsap="scroll-arrow"]').forEach((btn) => {
      if (btn.dataset.gsapInit) return;
      btn.dataset.gsapInit = true;

      const arrowImg = btn.querySelector(".scroll-arrow-img");
      if (arrowImg) {
        gsap.set(arrowImg, { x: 0, y: 0 });

        const hoverTl = gsap.timeline({ paused: true });
        hoverTl.to(arrowImg, { x: 3, y: -3, duration: 0.2, ease: "power1.inOut" });

        btn.addEventListener("mouseenter", () => hoverTl.play());
        btn.addEventListener("mouseleave", () => hoverTl.reverse());
      }
    });
  };

  // Initial call on DOM ready
  initPrimaryButtons();
  initSecondaryButtons();
  initCounterArrowButtons();
  initScrollArrowButtons();

  // Support for Shopify Section Updates in the Theme Editor
  document.addEventListener("shopify:section:load", () => {
    initPrimaryButtons();
    initSecondaryButtons();
    initCounterArrowButtons();
    initScrollArrowButtons();
  });
});
